import Brightness7Icon from "@mui/icons-material/Brightness7";
import ContrastIcon from "@mui/icons-material/Contrast";
import FlipIcon from "@mui/icons-material/Flip";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import { Box, Button } from "@mui/material";
import React, { useContext } from "react";

import { ImageSettingsContext, ImageSettingsContextType } from "context/ImageSettingsContext/imageSettingsContext";
import { Typography } from "new-components/typography/Typography";

import { ImageSettingButton } from "./ImageSettingButton";
import { ImageSettingsSlider } from "./ImageSettingsSlider";

export function CanvasToolbarExtraSettings() {
  const { imageSettings, updateSetting, toggleSetting, resetImageSettings } = useContext(
    ImageSettingsContext
  ) as ImageSettingsContextType;

  return (
    <Box className="@container">
      <Box className="flex flex-col @[600px]:flex-row justify-between items-center gap-6">
        <Box className="flex w-full gap-6 justify-between">
          <ImageSettingsSlider
            id="canvas-tool-bar-zoom-out-button"
            data-testid="canvas-tool-bar-zoom-out-button"
            title="Brightness"
            icon={<Brightness7Icon sx={{ width: "12px", height: "12px" }} />}
            value={imageSettings.brightness}
            onChange={(newValue) => updateSetting("brightness", newValue)}
          />

          <ImageSettingsSlider
            id="canvas-tool-bar-settings-contrast"
            data-testid="canvas-tool-bar-settings-contrast"
            title="Contrast"
            icon={<ContrastIcon sx={{ width: "12px", height: "12px" }} />}
            value={imageSettings.contrast}
            onChange={(newValue) => updateSetting("contrast", newValue)}
          />

          <Box className="flex flex-col items-center w-min">
            <Typography variant="small" fontWeight="semibold" gutterBottom color="#919599">
              Rotation
            </Typography>
            <Box sx={{ display: "flex", gap: "16px" }}>
              <ImageSettingButton
                name="canvas-tool-bar-rotate-right-button"
                data-testid="canvas-tool-bar-rotate-right-button"
                aria-label="Rotate right"
                onClick={() => updateSetting("rotation", Math.abs(imageSettings.rotation + 90) % 360)}
                icon={<RotateRightIcon sx={{ width: "12px" }} color="primary" />}
              />
              <ImageSettingButton
                name="canvas-tool-bar-rotate-left-button"
                data-testid="canvas-tool-bar-rotate-left-button"
                aria-label="Rotate left"
                onClick={() => updateSetting("rotation", Math.abs(imageSettings.rotation + 270) % 360)}
                icon={<RotateLeftIcon sx={{ width: "12px" }} color="primary" />}
              />
            </Box>
          </Box>

          <Box className="flex flex-col items-center w-min">
            <Typography variant="small" fontWeight="semibold" gutterBottom color="#919599">
              Flipping
            </Typography>
            <Box sx={{ display: "flex", gap: "16px" }}>
              <ImageSettingButton
                name="canvas-tool-bar-flip-image-horizontally"
                data-testid="canvas-tool-bar-flip-image-horizontally"
                aria-label="Horizontal flip"
                onClick={() => toggleSetting("flipX")}
                icon={<FlipIcon sx={{ width: "12px" }} color="primary" />}
              />
              <ImageSettingButton
                name="canvas-tool-bar-flip-image-vertically"
                data-testid="canvas-tool-bar-flip-image-vertically"
                aria-label="Vertical flip"
                onClick={() => toggleSetting("flipY")}
                icon={<FlipIcon sx={{ width: "12px" }} className="rotate-90" color="primary" />}
              />
            </Box>
          </Box>

          <Button
            onClick={resetImageSettings}
            variant="outlined"
            className="w-full @[600px]:w-min h-min rounded-xl py-[3px] px-[10px] mt-auto"
          >
            Reset
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
